<template>
    <div class="comment">
        <p class="title">客户评价</p>
        <div class="content">
            <p class="empty" v-if="star==0">暂无评价</p>
            <CommentStar
            :precent="precent||0"
            :key="index"
            v-else
            v-for="(precent,index) in precentList"
            />
            <span class="num" v-if="star!=0">{{starsNum}}</span>
        </div>
    </div>
</template>
<script>
import CommentStar from "@/components/horseman/CommentStar";
export default {
    model: {
		prop: "stars",
		event: "updateStars"
	},
    props:{
        star: {
			type: Number,
			default: 0,
			required: true
		},
    },
    computed: {
		starsNum() {
			return this.star.toFixed(1);
		},
		// 将总数转换成百分比的数组
		precentList() {
			let total = Math.floor(parseFloat(this.star) * 100),
				// 整数
				num = Math.floor(total / 100),
				// 小数部分
				precent = total % 100,
				list = [];
			list = list.concat(("100,".repeat(num) + precent).split(","));
			list.length = 5;
			return list;
		}
	},
    components:{
        CommentStar,
    }
}

</script>
<style lang="scss" scoped>
@import "~@/scss/libs.scss";
.comment {
    padding:px2rem(30) px2rem(20);
    border-top: px2rem(10) solid #f1f1f1;
    @include dis-flex(center,space-between);
    .title {
        font-size: px2rem(34);
        color: $grayBlue;
    }
    .num{
        font-size: px2rem(28);
        color: $grayBlue;
        margin-left: px2rem(20);
    }
    .content {
        .empty {
            font-size: px2rem(28);
            color: $shallowGrayBlue;
        }
    }
}
</style>
